var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRize2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19799 42.0032C4.06591 42.1933 4.79827 38.3526 7.80037 32.8292C6.80526 31.9794 5.85487 31.0291 4.96598 29.9613C3.23852 34.8026 1.79058 39.7391 0.616577 44.7873L9.19799 42.0032Z",
    fill: "url(#paint0_linear_3421_137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8006 32.8293C4.79851 38.3527 4.06615 42.1934 9.19823 42.0033L19.8034 38.5595C15.3701 37.5309 11.2835 35.7978 7.8006 32.8293Z",
    fill: "url(#paint1_linear_3421_137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80054 32.8293C11.2834 35.7978 15.3701 37.5309 19.8033 38.5595C17.3435 34.3331 15.1912 29.0445 13.6258 23.4764C11.4176 26.8195 9.32115 30.0396 7.80054 32.8293Z",
    fill: "url(#paint2_linear_3421_137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80069 32.8294C9.32131 30.0397 11.4177 26.8196 13.626 23.4765C12.7818 20.4632 12.1054 17.3716 11.6414 14.3136C9.09769 19.4066 6.86708 24.6225 4.96631 29.9614C5.8552 31.0292 6.80558 31.9796 7.80069 32.8294Z",
    fill: "url(#paint3_linear_3421_137)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6414 14.3133C12.1054 17.3713 12.7818 20.4629 13.626 23.4762C15.7112 20.3175 17.9027 17.0527 19.8035 13.9276C18.2046 11.3057 16.807 8.77875 15.8398 6.50342C14.3583 9.07505 12.9607 11.6802 11.6414 14.3133Z",
    fill: "url(#paint4_linear_3421_137)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8034 13.9277C17.9026 17.0528 15.7111 20.3232 13.6259 23.4763C15.1912 29.0444 17.3435 34.333 19.8034 38.5594C22.2632 34.333 24.4155 29.0444 25.9809 23.4763C23.8956 20.3176 21.7041 17.0528 19.8034 13.9277Z",
    fill: "url(#paint5_linear_3421_137)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8035 13.9276C21.7042 17.0527 23.8957 20.3231 25.981 23.4762C26.8251 20.4629 27.5016 17.3713 27.9656 14.3133C26.6462 11.6802 25.243 9.07505 23.7615 6.50342C22.7944 8.77875 21.4023 11.3057 19.8035 13.9276Z",
    fill: "url(#paint6_linear_3421_137)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8035 13.9276C21.4024 11.3057 22.7944 8.77879 23.7616 6.50346C22.5037 4.31198 21.1788 2.14846 19.8035 0.00170898C18.4227 2.14846 17.1033 4.31198 15.8398 6.50346C16.807 8.77879 18.2046 11.3057 19.8035 13.9276Z",
    fill: "url(#paint7_linear_3421_137)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9655 14.3136C27.5015 17.3716 26.825 20.4632 25.9808 23.4765C28.1891 26.8196 30.2855 30.0397 31.8061 32.8294C32.8012 31.9796 33.7516 31.0292 34.6405 29.9614C32.7397 24.6225 30.5091 19.4066 27.9655 14.3136Z",
    fill: "url(#paint8_linear_3421_137)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8063 32.8293C30.2856 30.0396 28.1892 26.8195 25.981 23.4764C24.4156 29.0445 22.2633 34.3331 19.8035 38.5595C24.2367 37.5309 28.3234 35.7978 31.8063 32.8293Z",
    fill: "url(#paint9_linear_3421_137)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8063 32.8293C28.3234 35.7978 24.2367 37.5309 19.8035 38.5595L30.4086 42.0033C35.5407 42.1934 34.8084 38.3527 31.8063 32.8293Z",
    fill: "url(#paint10_linear_3421_137)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8062 32.8292C34.8083 38.3526 35.5406 42.1933 30.4086 42.0032L38.99 44.7873C37.816 39.7391 36.3624 34.8026 34.6406 29.9613C33.7517 31.0291 32.8013 31.9794 31.8062 32.8292Z",
    fill: "url(#paint11_linear_3421_137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3421_137",
    x1: 6.18614,
    y1: 32.6692,
    x2: 1.03222,
    y2: 44.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9A6",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3421_137",
    x1: 12.6237,
    y1: 32.8293,
    x2: 12.6237,
    y2: 42.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3421_137",
    x1: 19.3205,
    y1: 38.0726,
    x2: 9.92703,
    y2: 25.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3421_137",
    x1: 4.93952,
    y1: 19.5352,
    x2: 10.1766,
    y2: 33.1682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3421_137",
    x1: 15.7224,
    y1: 6.50342,
    x2: 15.7224,
    y2: 23.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3421_137",
    x1: 19.7362,
    y1: 38.5713,
    x2: 19.7362,
    y2: 23.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEDFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB4D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3421_137",
    x1: 23.8845,
    y1: 6.50342,
    x2: 23.8845,
    y2: 23.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3421_137",
    x1: 19.8007,
    y1: 0.00170898,
    x2: 19.8007,
    y2: 13.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0251CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3421_137",
    x1: 31.6234,
    y1: 21.2809,
    x2: 30.3107,
    y2: 32.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC34C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3421_137",
    x1: 21.1495,
    y1: 39.0702,
    x2: 27.6335,
    y2: 30.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3421_137",
    x1: 26.9832,
    y1: 32.8293,
    x2: 26.9832,
    y2: 42.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3421_137",
    x1: 38.6062,
    y1: 44.7228,
    x2: 34.4498,
    y2: 29.6766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRize2);
export default __webpack_public_path__ + "static/media/rize2.ead16258a77c974e9d5b1889bcf23345.svg";
export { ForwardRef as ReactComponent };